/**
 * - fill:  fractional unit (fr) — column fills available space proportionally
 * - hug:   auto (content-based height/width)
 * - fixed: explicit pixel length (displayed as px in UI, stored as vw in the JSON)
 */
export type GridTrackMode = 'fill' | 'hug' | 'fixed';

export const GRID_TRACK_MODE: Record<string, GridTrackMode> = {
	FILL: 'fill',
	HUG: 'hug',
	FIXED: 'fixed',
};

export type GridTrack = {
	mode: GridTrackMode;
	value?: string | number;
};

/** Fractional shares for fill mode (stored without unit; UI labels append `fr`). */
export const FILL_FR_OPTIONS = ['0.25', '0.5', '0.75', '1', '2', '3', '4', '5'] as const;

export const MAX_GRID_COLUMNS = 24;
export const MIN_GRID_COLUMNS = 1;

/** Fallback row height (in vw) when collapsing an expanded row with no numeric value. */
export const DEFAULT_GRID_CELL_HEIGHT = '5vw';
export const DEFAULT_FIXED_VALUE = 100;
export const DEFAULT_FILL_VALUE = '1';

export const DEFAULT_COLUMN_TRACK: GridTrack = { mode: GRID_TRACK_MODE.FILL, value: DEFAULT_FILL_VALUE };
export const DEFAULT_ROW_TRACK: GridTrack = { mode: GRID_TRACK_MODE.FIXED, value: DEFAULT_FIXED_VALUE };
